export default "__VITE_ASSET__CudEix$e__"